import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import styles from '../../styles/Popup/Popup.module.css';

type PopupProps = {
  clickCloseButton?: () => void;
  className?: string;
  children: string | React.ReactNode;
  style?: React.CSSProperties;
};

export default function Popup(props: PopupProps) {
  const closePopup = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    props.clickCloseButton?.();
  }, [props.clickCloseButton]);

  return createPortal(
    <div className={styles.bg}>
      <div className={styles.box} style={props.style}>
        <div className={styles.close}>
          <button type="button" className={styles.cross} onClick={closePopup}>
            <div style={{
              fontSize: "10px",
              width: "18px",
              height: "18px",
              textAlign: "center",
              lineHeight: "15px",
              border: "1px solid black",
              borderRadius: "5px",
              color: "var(--black)"
            }}>
              x
            </div>
          </button>
        </div>
        {props.children}
      </div>
    </div>,
    document.body
  );
}